<script lang="ts">
  import { push } from "svelte-spa-router";
	import { ApiService } from "../services/api.service";
	import BlueButton from "../organisms/BlueButton.svelte";
	import ErrorMessage from "../atoms/ErrorMessage.svelte";
  import TextInput from "../atoms/forms/TextInput.svelte";
	import SmallBoard from "../molecules/SmallBoard.svelte";
	import Link from "../atoms/Link.svelte";

  let username = ''
  let password = ''
	let isError = false
	let errorMessage = ''

  const handleUsername = (event) => username = event.detail.value
  const handlePassword = (event) => password = event.detail.value

	const keypress = (event) => {
		const ENTER = 13
		if (event.detail.value === ENTER) {
			login()
		}
	}

	const login = async () => {
		if (username === '' || password === '') {
			isError = true
			errorMessage = 'ユーザー名とパスワードは必須です。'
			return
		}

		const client = ApiService.createClient()
		try {
		  const { data } = await client.post('/login', {
		  	username,
		  	password
		  })
			console.log(data)
			window.localStorage.setItem('token', data.token)
		  push('/home')
		} catch (e) {
			if (e.response.data.message === "username or password is wrong.") {
				errorMessage = 'ユーザー名かパスワードが間違っています。'
			} else {
				alert('エラーが発生しました。管理者にお問い合わせください。')
			}
		}
	}
</script>

<SmallBoard title={process.env.APP_NAME}>
	<TextInput inputType="text" placeholder="ユーザー名" on:input={handleUsername} klass="mt-10" isError={isError} focus on:keypress={keypress}/>
	<TextInput inputType="password" placeholder="パスワード" on:input={handlePassword} klass="mt-6" isError={isError} on:keypress={keypress}/>

	<div class="mt-4">
		<ErrorMessage message={errorMessage} center />
	</div>

	<BlueButton click={login} klass="mt-3" full={true}>
  	ログイン
	</BlueButton>

	<Link url="/resetPassword" klass="text-sm">
		パスワードを再発行する
	</Link>
</SmallBoard>